class FetchDisplayedLogo {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchDisplayedLogo;
